function changeTextFieldFromSelect(select, textField) {
  var val = select.options[select.selectedIndex].value;
  textField.value = (val == "#") ? "" : val; 
}

function changeSelectFromTextField(textField, select) {
  for(var i=0; i<select.options.length; i++) {
    if(select.options[i].value.toLowerCase() == textField.value.toLowerCase()) {
      select.selectedIndex = i;
      return;
    }
  }
  select.selectedIndex = 0;
  if(textField.value.length == 0) textField.value = select.options[select.selectedIndex].value;
}

function updateValuesByFieldName(form, value, namePrefix) {
  for(var i=0; i<form.elements.length; i++) if(form.elements[i].name.indexOf(namePrefix) == 0) {
    form.elements[i].value = value;
  }
}

function onWithdrawTypeChanged(withdrawTypeSelect, rowName) {
  var rows = document.getElementsByName(rowName);
  var withdrawType = withdrawTypeSelect.options[withdrawTypeSelect.selectedIndex].value;
  var i;
  for(i=0; i<rows.length; i++) {
    var withdraw = rows[i].getAttribute('withdraw');
    if(withdraw != null) {
      if(withdraw == withdrawType) {
        rows[i].style.display = '';
      } else {
        rows[i].style.display = 'none';
      }
    }
  }
}

function showNextUploadFile(rowId, nextButtonId) {
  var row = document.getElementById(rowId);
  var nextButton = document.getElementById(nextButtonId);
  row.style.display='';
  nextButton.style.visibility='hidden';
}

function setBits(value, bits) {
  return value | bits;
}

function clearBits(value, bits) {
  return value &~ bits; 
}

function allBitsSet(value, bits) {
  return (value & bits) == bits;
} 

function anyBitsSet(value, bits) {
  return (value & bits) > 0;
}

function setupCheckboxBits(field, checkbox, bits) {
  if(checkbox.checked) field.value=setBits(field.value, bits); else field.value=clearBits(field.value, bits);
}

//init-format
$(function() {
  var regional = jQuery.datepicker._defaults;
  jQuery.format.locale({
    date: {
      monthsFull: regional["monthNames"],
      monthsShort: regional["monthNamesShort"],
      daysFull: regional["dayNames"],
      daysShort: regional["dayNamesShort"]
    }
  });
});